import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSidebarStore } from "@/stores/sidebarStore";
import { cn } from "@/lib/utils";
import { ThemeToggle } from "@/components/common/ThemeToggle";

interface SidebarHeaderProps {
  collapsed: boolean;
}

export function SidebarHeader({ collapsed }: SidebarHeaderProps) {
  const { toggleSidebar } = useSidebarStore();

  return (
    <div className={cn(
      "flex h-18 items-center border-b px-4 py-2",
      collapsed ? "justify-center" : "justify-between"
    )}>
      {collapsed ? (
        <div className="flex flex-col gap-2">
          <Button variant="ghost" size="icon" onClick={toggleSidebar}>
            <Menu className="h-5 w-5" />
          </Button>
          <ThemeToggle />
        </div>
      ) : (
        <>
          <span className="text-2xl font-bold">CL</span>
          <div className="flex items-center gap-2">
            <ThemeToggle />
            <Button variant="ghost" size="icon" onClick={toggleSidebar}>
              <Menu className="h-5 w-5" />
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
